// @flow
import type {SearchParamsType} from '../reducers/searchParams';
import {
    INSTANT_BOOK_FILTER_ID,
    INSTANT_BOOK_FILTER_LABEL,
    LEGACY_INSTANT_BOOK_ID,
    INSTANT_BOOK_SLOT_VALUE
} from '../constants/filters';
import type {FilterGroupType} from '../components/MoreFilters/MoreFilters';

export const newArrayFromFilters = (values: SearchParamsType): string[] => {
    const newArray = (values.filter && [].concat(values.filter)) || [];
    newArray.sort();
    return newArray;
};

/* TODO: these need to be changed to the new canonical integer refinement references when those are available */
const excludedFilters = [
    'bedrooms_title',
    'bedrooms_min_title',
    'bathrooms_title',
    'sleeps_title'
];

export const displayFilterGroup = ({
    filters = [],
    key
}: FilterGroupType): boolean => {
    return !(
        key &&
        (!filters ||
            filters.length <= 0 ||
            excludedFilters.includes(key.toLowerCase()))
    );
};

export const instantBookFilter = (filter: any): string | null => {
    const filtered = []
        .concat(filter || [])
        .map((f) => f.toLowerCase().trim())
        .filter(
            (f) =>
                INSTANT_BOOK_FILTER_ID === f ||
                LEGACY_INSTANT_BOOK_ID === f ||
                f.includes(INSTANT_BOOK_SLOT_VALUE)
        );
    return filtered.length ? filtered[0] : null;
};

const OLB_GROUP_KEYS = ['online_booking_title', 'booking_title'];

/**
 * Returns filter group filters (Refinements), with filtered out Instant Booking filter from OLB filter group
 *
 * @param {FilterGroupType} filterGroup
 * @returns {Refinement[]}
 */
export const filterGroupFilters = ({filters = [], key}: FilterGroupType) => {
    if (!filters) {
        return [];
    }

    if (OLB_GROUP_KEYS.includes(key.toLowerCase())) {
        return filters.reduce((acc, filter) => {
            if (!instantBookFilter(filter.key)) {
                acc.push(filter);
            }
            return acc;
        }, []);
    }

    return filters;
};

export const isOnlyInstantConfirmationFilter = (filters: string[]) => {
    return filters.length === 1 && !!instantBookFilter(filters);
};

/**
 * Return all selected filters from the filterGroups
 * @param {Object[]} filterGroups
 */
export const checkedFilters = (filterGroups?: Object[]): string[] => {
    if (!filterGroups) {
        return [];
    }
    return filterGroups.reduce(
        (acc, filterGroup) =>
            acc.concat(
                filterGroup.filters.filter((f) => f.checked).map((f) => f.key)
            ),
        []
    );
};

export const getFilterId = (
    event: SyntheticEvent<HTMLInputElement>
): ?string => {
    const filterId =
        (event.currentTarget && event.currentTarget.getAttribute('name')) || '';
    const matches = filterId.match(/:(.+$)/);

    if (!matches) {
        return null;
    }

    if (
        filterId === INSTANT_BOOK_FILTER_ID ||
        filterId === LEGACY_INSTANT_BOOK_ID
    ) {
        return INSTANT_BOOK_FILTER_LABEL;
    }

    return matches[1];
};
